import {
  AiVisualisationResponseFragment,
  DatasetObjectQueryColumn,
  DatasetObjectQueryResponse,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { FormattedValueWithUnit } from '../../common/formatHelper';
import { PieData } from '../../simulation/panels/SimulationPieChart';

export type GetPieChartDataParams = {
  visualisationType: AiVisualisationResponseFragment;
  queryResponse: DatasetObjectQueryResponse;
  getColor: (v: string) => [string, string];
  getFormatter: (
    column: DatasetObjectQueryColumn,
  ) => (v: number, cutOf?: number) => FormattedValueWithUnit;
};

export function getPieChartData(params: GetPieChartDataParams): PieData[] {
  const dimensionField = _.head(params.visualisationType?.dimensionColumns);
  const metricField = params.visualisationType?.metricColumn;
  const col = _.find(params.queryResponse.columns, c => c.name === metricField);
  const getFormatted = params.getFormatter(col);

  const data = _.map(params.queryResponse.result, (row, index) => {
    const key = row[dimensionField];
    const dataRaw = row[metricField];
    const chartItem: PieData = {
      id: key,
      label: key,
      color: params.getColor(key),
      value: dataRaw,
      formatted: getFormatted(dataRaw),
    };
    return chartItem;
  });

  return data;
}

export function getStackedBarChartData(params: GetPieChartDataParams) {
  const indexBy = _.head(params.visualisationType?.dimensionColumns);
  const dimensions = _.tail(params.visualisationType?.dimensionColumns);

  const metricField = params.visualisationType?.metricColumn;
  const col = _.find(params.queryResponse.columns, c => c.name === metricField);
  const getFormatted = params.getFormatter(col);
  return [];
}
